// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Image, Divider, Button } from '@chakra-ui/react';
import { NavLink, Link } from 'react-router-dom';

// Assets
import partner1 from 'assets/img/become-a-partners/1.png';
import partner2 from 'assets/img/become-a-partners/2.png';
import partner3 from 'assets/img/become-a-partners/3.png';
import partner4 from 'assets/img/become-a-partners/4.png';
import partner5 from 'assets/img/become-a-partners/5.png';

const Partners = () => {
    const importAll = (context) => context.keys().map(context);
    const images = importAll(require.context('assets/img/become-a-partners', false, /\.png$/));

    const data = images.map((img, index) => ({
        id: index + 1,
        src: img,
    }));

    const listToRight = useAnimation();
    useEffect(() => {
        if (!data) { return; } 

        const animateRight = async () => {
            await listToRight.start({
                x: ['-100%', '0%'],
                transition: { duration: 25, ease: 'linear', repeat: Infinity, repeatType: 'reverse' },
            });
        };

        animateRight();

        return () => listToRight.stop();
    }, [data, listToRight]);

    return (
        <Box zIndex="1" overflow="visible" width="100%" mb="0px" alignItems="center" whiteSpace="nowrap" position="relative">
            <motion.div
                style={{ display: 'flex', gap: '0px' }}
                animate={listToRight}
                initial={{ x: '-100%' }}
            >
                {[...data, ...data].map((item, index) => (
                    <Box 
                        key={`bottom-${index}`} 
                        p="0px 20px" 
                        minW="264px" 
                        w="100%" 
                        textAlign="center">
                        <Image src={item.src} alt="Become a partner" h="60px" objectFit="contain" w="100%" />
                    </Box>
                ))}
            </motion.div>
        </Box>
    );
};

export default Partners;